export const ready = (fn: () => void) => {
  if (document.readyState !== 'loading') fn();
  else document.addEventListener('DOMContentLoaded', fn);
};

ready(() => {
  console.log('main.ts ready');
});
